const Logo = (props) => (
  <img alt="Logo" src="/static/images/logo.png" {...props} />
);

export default Logo;
